import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Header from '../components/Header';
import { useHistory } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import styled from 'styled-components';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import {
    Link
} from "react-router-dom";
import { connect } from 'react-redux';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroller';

import Button from '@material-ui/core/Button';
import CampaignsActions from '../actions/campaigns.actions';
import CompanyProfileActions from "../actions/companyProfile.actions";

const StyledTH = styled(Th)`
    border: 1px solid #2a2727;
    background: #3F3F3F;
    color: white;
    padding-left: 10px
`

const StyledTD = styled(Td)`
    border: 1px solid #2a2727;
    background: #525252;
    color: white;
    padding: 10px
`

const StyledBtn = styled(Button)`
    color: #fff!important;
    border-color: #000!important; 
    background-color: #3f3f3f!important;
    padding-left: 25px;
    padding-right: 25px;
    width: auto;
    display: block;
    margin: auto;
    &#floating {
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 50px;
        min-width: auto;
        height: 50px;
        padding: 0;
        border-radius: 50%;
    }
`

const StyledTR =styled(Tr)`
  border-color: #2a2727!important;
  padding: 0!important
`

const Campaigns = (props) => {
    let history = useHistory();
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    useEffect(()=>{
        if (props.profile && (Object.keys(props.profile).length > 0) && !props.profile._id) {
            history.push('/profile');
        }
    },[props.profile]);

    useEffect(()=>{
        props.resetCampaignsStore();
        props.getCompanyProfile();
    },[]);

    const fetchCampaigns = ()=>{
        props.getCampaigns({
            lastKey: lastKey,
            recordsPerPage
        })
    }

    useEffect(()=>{
        if (!props.auth.access_token) {
            history.push('/')
        }
    },[props.auth.access_token]);

    const {
        lastKey,
        initialCall
    } = props;

    return (
        <Container fixed>
            {
                (Object.keys(props.profile).length > 0) &&
                <Header IsProfileCreated={!!props.profile._id}>
                    <Typography component="div" align="left" style={{ marginTop: '0px' }}>
                        <InfiniteScroll
                            loadMore={fetchCampaigns}
                            hasMore={initialCall || !!lastKey}
                            loader={<div className="loader" key={0} style={{textAlign: 'center', color: 'black'}}>Loading ...</div>}
                        >
                            
                            <Table style={{borderCollapse: 'collapse'}}>
                                {
                                    props.campaignList && props.campaignList.length > 0 &&
                                    <Thead>
                                        <StyledTR>
                                            <StyledTH>Name</StyledTH>
                                            <StyledTH>Start Date</StyledTH>
                                            <StyledTH>End Date</StyledTH>
                                            <StyledTH>Status</StyledTH>
                                            <StyledTH>Reward QRCode</StyledTH>
                                            <StyledTH>Actions</StyledTH>
                                        </StyledTR>
                                    </Thead>
                                }
                                <Tbody>
                                {
                                    (props.campaignList || []).map((obj, i)=>{
                                        return <StyledTR key={i}>
                                            <StyledTD>{obj.name}</StyledTD>
                                            <StyledTD>{moment.utc(obj.startDate).format('MM/DD/YYYY')}</StyledTD>
                                            <StyledTD>{moment.utc(obj.endDate).format('MM/DD/YYYY')}</StyledTD>
                                            <StyledTD>{obj.status}</StyledTD>
                                            <StyledTD><a href={`${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaign/${obj._id}/reward-qrcode`} target="_blank" style={{color: 'white'}}>Click to Download</a></StyledTD>
                                            <StyledTD>
                                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                                    <Link to={`/campaign/${obj._id}`} style={{color: 'white', marginBottom: '10px'}}>View/Edit Campaign</Link>
                                                    <Link to={`/campaign/${obj._id}/rewards`} style={{color: 'white'}}>Create/Edit Rewards</Link>
                                                {
                                                    false &&
                                                    <Link to={`/campaign/${obj._id}/claims`} style={{color: 'white'}}>Claims Dashboard</Link>
                                                }
                                                </div>
                                            </StyledTD>
                                        </StyledTR>
                                    })
                                }
                                </Tbody>
                            </Table>
                        </InfiniteScroll>
                        {
                            !lastKey && props.campaignList && props.campaignList.length === 0 &&
                            <React.Fragment>
                                <h3 style={{textAlign: 'center', color: '#3F3F3F'}}>You have not created any campaign.</h3>
                                <StyledBtn variant="outlined" color="primary" onClick={()=>history.push('/campaign/new')}>
                                    Create your first campaign
                                </StyledBtn>
                            </React.Fragment>
                        }
                            <StyledBtn id="floating" variant="outlined" color="primary" onClick={()=>history.push('/campaign/new')}>
                                +
                            </StyledBtn>
                    </Typography>
                </Header>
            }
        </Container>
        )
}


const mapStateToProps = (state)=>{
    return {
        profile: state.companyProfile.profile,
        campaignList: state.campaigns.campaignList,
        initialCall: state.campaigns.initialCall,
        lastKey: state.campaigns.lastKey,
        hasMoreCampaigns: state.campaigns.hasMoreCampaigns,
        auth: state.auth
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        getCompanyProfile: (cb) =>
        dispatch(CompanyProfileActions.getCompanyProfile(cb)),
        getCampaigns: (payload)=>dispatch(CampaignsActions.getCampaigns(payload)),
        resetCampaignsStore: ()=>dispatch(CampaignsActions.resetCampaignsStore())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns)